<template>
  <row class="el-item propagate-drag col-md-12">
    <prefix>
      <input
        :id="model.idForProp('label_title')"
        type="checkbox"
        disabled
      >
    </prefix>
    <property-change-detector
      :left="model"
      :right="model.publishedEquivalent"
      :properties="[['label_title', 'label']]"
      tag="prefix"
    />
    <column>
      <object-model-property-labelable
        ref="itemComponent"
        :object-model-property="model"
        :placeholder="placeholder"
        v-on:paste="handlePaste"
        v-on:blur="blur"
        v-on:keydown:enter="enter"></object-model-property-labelable>
    </column>
    <suffix>
      <dynamic-child-context-menu
        :model="model"
        v-on:remove="tryRemove"
      ></dynamic-child-context-menu>
    </suffix>

    <confirmation-modal
      v-if="modalStateFor(vueModalID.confirmChange).isVisible"
      :state="modalStateFor(vueModalID.confirmChange)"
      :override-config="confirmationConfig"
      @toggle-modal="handleConfirmation"
    />
  </row>
</template>

<script lang="ts">
  import Vue from "vue";
  import DynamicChildMixin from "~/mixins/dynamicChildMixin";
  import ObjectModelPropertyLabelable from "./object-model-property-labelable.vue";
  import ObjectModelProperty from "~/models/objectModelProperties/objectModelProperty";
  import PropertyChangeDetector from "./property-change-detector.vue"
  import ConfirmationModal from "~/components/modals/confirmationModal.vue";
  import {IConfirmModalConfig} from "~/interfaces/modalInterfaces";
  import ObjectModelPropertyDefinition from "~/models/objectModelProperties/objectModelPropertyDefinition";

  export default Vue.extend({
    components: {
      ObjectModelPropertyLabelable,
      PropertyChangeDetector,
      ConfirmationModal,
    },
    props: {
      model: {
        type: Object as () => ObjectModelProperty
      },
      placeholder: {
        type: String,
        default: "option label",
      }
    },
    mixins: [DynamicChildMixin],
    data: function () {
      return {};
    },
    computed: {
      confirmationConfig(): Partial<IConfirmModalConfig> {
        return ObjectModelPropertyDefinition.changeWarningConfig()
      },
    },
    methods: {
      tryRemove() {
        !!this.model.publishedEquivalent ? this.showConfirmation() : this.deleteItem()
      },
      showConfirmation() {
        this.showModal(this.vueModalID.confirmChange);
      },
      handleConfirmation(data) {
        this.hideModal(this.vueModalID.confirmChange);
        const action = $(data.event.currentTarget).data('action');
        if (action === 'affirm') {
          this.deleteItem()
        }
      },
    }
  });
</script>